import User from './User'
import {
  StripeSubscriptionStatus,
  type SubscriberUserProfileFragment,
} from '@generatedTypes/graphql'

type SubscriberUserProfile = SubscriberUserProfileFragment & {
  photoURL: string | null | undefined
}

export default class SubscriberUser extends User {
  key: string
  profile: SubscriberUserProfile

  constructor(profile: SubscriberUserProfile) {
    super(
      profile.aclIdentities,
      profile.roles,
      profile.key,
      profile.preferences,
    )
    this.key = profile.key
    this.profile = profile
  }

  hasAnActiveSubscription(): boolean {
    return this.profile.subscriptionActive
  }
  hasPastDueSubscription(): boolean {
    return (
      this.profile.subscriptions?.some(
        (sub) => sub.subscriptionStatus === StripeSubscriptionStatus.PastDue,
      ) ?? false
    )
  }
}
